
let BUILD;
if (process.env.NODE_ENV === 'development') {
  BUILD = {
    PUBLIC_PATH: process.env.PUBLIC_PATH_OVERRIDE 
      ? '/' + process.env.PUBLIC_PATH_OVERRIDE + '/' 
      : '/',
    LIBRARY_NAME: 'incidents-webform',
    ENV: 'dev',
    BASE_URL: 'http://scrum1.local:8086/rest/frontend',
    CLASSIC_URL: 'https://sandbox.logicmanager.local',
    GA_ID: '',
    HORIZON_SUBDOMAIN: 'luigi',
    MARKETING_URL: '/static/login_placeholder.html',
    RECAPTCHA_SITE_KEY: '6LfdymoUAAAAAI94kGg4AHwLR6gX9J5huvVSGtX8'
  };
} else {
  BUILD = {
    PUBLIC_PATH: process.env.PUBLIC_PATH_OVERRIDE 
      ? '/' + process.env.PUBLIC_PATH_OVERRIDE + '/' 
      : '/',
    LIBRARY_NAME: 'incidents-webform',
    BASE_URL: '/rest-api/rest/frontend',
    CLASSIC_URL: '',
    GA_ID: '',
    HORIZON_SUBDOMAIN: 'my',
    MARKETING_URL: 'https://www.logicmanager.com/welcome/',
    RECAPTCHA_SITE_KEY: '6Lc9oRcTAAAAAFKq3MM2l6d-wH4VqHaEZmo07oQQ'
  };
}

module.exports = BUILD;